import { ILoginResponseData, IRefreshTokenData } from '../../models';
import { API } from '../Api';

export const loginAPI = (email: string, password: string, passCode?: string) => {
  // const formData = new URLSearchParams();
  // formData.append('email', email);
  // formData.append('password', password);
  return API.post<ILoginResponseData>(
    '/v1/identity-service/accounts/login',
    { email, password, passCode },
    {
      // SEC-10: withCredentials để trình duyệt LƯU cookie httpOnly refresh (cab_rt) từ response.
      withCredentials: true,
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'Content-Type': 'application/json;charset=UTF-8',
        'clean-request': 'no-clean',
      },
    },
  );
};

export const loginThreeRdAPI = (provider: string, accessToken: string) => {
  return API.post<ILoginResponseData>(
    '/v1/identity-service/accounts/external-login',
    { provider, accessToken },
    {
      withCredentials: true, // SEC-10: lưu cookie httpOnly refresh khi đăng nhập Google/Facebook.
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'Content-Type': 'application/json;charset=UTF-8',
        'clean-request': 'no-clean',
      },
    },
  );
};

// SEC-10: logout gọi revoke để BE thu hồi refresh token + xoá cookie httpOnly cab_rt (không refresh lại được).
export const logoutAPI = () =>
  API.post(
    '/v1/identity-service/tokens/revoke',
    {},
    { withCredentials: true, headers: { 'clean-request': 'no-clean' } },
  );

// QA S-28: logout admin phải revoke refresh token phía server (admin lưu ở localStorage cmsRefreshToken, không dùng cookie cab_rt).
export const logoutCmsAPI = (refreshToken?: string) =>
  API.post(
    '/v1/identity-service/tokens/revoke',
    { refreshToken },
    { headers: { 'clean-request': 'no-clean' } },
  );

export const refreshTokenAPI = ({
  fingerprintHash,
}: {
  fingerprintHash?: string;
} = {}) => {
  return API.post<IRefreshTokenData>(
    '/v1/identity-service/tokens/refresh',
    { fingerprintHash },
    {
      // SEC-10: gửi cookie httpOnly refresh (cab_rt) — BE chỉ đọc refresh token từ cookie.
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'clean-request': 'no-clean',
      },
    },
  );
};
